import HttpService from './httpService';
import config from '../../config';

class DocumentosApiService extends HttpService {
  async generarBolnot(data) {
    return this.post('generarBolnot', data, { responseType: 'blob' });
  }

  async generarJustificanteExamenOrdinario(data) {
    return this.post('generarJustificanteExamenOrdinario', data, { responseType: 'blob' });
  }

  async generarJustificanteExamenExtraordinario(data) {
    return this.post('generarJustificanteExamenExtraordinario', data, { responseType: 'blob' });
  }
}

const documentosApiService = new DocumentosApiService(config.REACT_APP_NODE_API);
export default documentosApiService;
